export const divideTwoNumbers = (value1: number, value2: number, fractionDigits?: number) =>
  parseFloat((value1 / value2).toFixed(fractionDigits));
